import React, { useState } from "react";
import '../pages/Home.css';
import RemoveOutlinedIcon from '@mui/icons-material/RemoveOutlined';
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
import { Box, Grid2, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';

interface QuestionProps {
  question: string;
  answer: string;
}

const QuestionAnswer: React.FC<QuestionProps> = ({ question, answer }) => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

  const [isOpen, setIsOpen] = useState(false);

  // Toggle the visibility of the answer
  const toggleAnswer = () => {
    setIsOpen(!isOpen);
  };

  return (
    <Box className="questions-container" style={{ marginBottom: '10px' }}>
      <Box className={isSmallScreen ? "faq-section faq-section-sm" : "faq-section"}
        style={{ 
          display: 'flex', 
          justifyContent: 'space-between', 
          alignItems: 'center',
          padding: '8px 10px', // Add some padding
          background: 'rgba(0, 0, 0, 0.2)', // Subtle background
          borderRadius: '6px' // Rounded corners
        }}>
        <div style={{ width: 'calc(100% - 45px' }}>
          <p style={{
            color: '#dddddd', // Lighter color instead of bright white
            textAlign: 'left',
            fontWeight: 500, // Slightly reduced font weight
            fontSize: '0.95rem', // Slightly smaller font size
            alignSelf: 'flex-start',
            wordWrap: "break-word",
            width: '100%',
            marginTop: 0,
            marginBottom: 0,
            opacity: 0.9 // Slight transparency for subtlety
          }}>
            {question}
          </p>
          {/* Conditionally render the answer */}
          {isOpen && (
            <Grid2
              style={{
                // marginTop: '30px',
                // border: '1px solid #ccc',
                borderRadius: '5px',
                color: '#aaaaaa', // Even lighter color for the answer
                textAlign: 'left',
                width: '100%',
                marginTop: 8,
                fontSize: '0.85rem', // Smaller font size for answers
                fontWeight: 400, // Lighter font weight
              }}>
              {answer}
            </Grid2>
          )}
        </div>
        <button onClick={toggleAnswer} style={{
          backgroundColor: 'transparent', color: '#ffffff', height: 36, width: 36, marginTop: 0
        }}>
          {isOpen
            ? <RemoveOutlinedIcon style={{ fontSize: '24px', position: 'relative', right: '9px', top: '-4px' }}/>
            : <AddOutlinedIcon style={{ fontSize: '24px', position: 'relative', right: '9px', top: '-4px' }}/>}
        </button>
      </Box>
    </Box>
  );
};

export default QuestionAnswer;